import { useEffect } from "react";
import "../../../../../../styles/selectBar.css";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 드롭다운만 있던 화면에 제목/설명/힌트 추가
 *    — "세트를 고르면 다음 단계에서 그 세트의 지문이 나온다"는 관계 안내
 * 2. selectedTypes 구조({key:"comprehensive", index})와 초기화 로직은 기존 그대로
 */
const ComprehensiveSelectionPage = ({
  worksheet,
  selectedTypes,
  setSelectedTypes,
}) => {
  const maxExamIndex =
    setSelectedTypes === undefined ? 99 : worksheet.data.length;
  const examIndex =
    selectedTypes.find((item) => item.key === "comprehensive")?.index || 0;

  const setExamIndex = (index) => {
    setSelectedTypes([{ key: "comprehensive", index }]);
  };

  useEffect(() => {
    if (setSelectedTypes !== undefined) {
      setExamIndex(maxExamIndex);
    }
    // eslint-disable-next-line
  }, [maxExamIndex]);

  return (
    <div style={{ padding: "22px" }}>
      <div className="ws-modal-title">세트 선택</div>
      <p className="ws-modal-sub" style={{ marginBottom: "16px" }}>
        출제할 내용이해 워크북 세트를 고르세요.
      </p>

      <select
        id="typeSelect"
        value={examIndex}
        onChange={(e) => setExamIndex(Number(e.target.value))}
        disabled={setSelectedTypes === undefined}
        className="customSelect"
        style={{
          padding: "9px 13px",
          fontSize: "0.9rem",
          color: "#3A434E",
          // 원서 세트 이름("Chapter 1. ... · 1세트")이 길어 폭을 내용에 맞춘다.
          minWidth: "140px",
          maxWidth: "100%",
          border: "1.5px solid #E6EDEC",
          borderRadius: "10px",
          cursor: "pointer",
          backgroundColor: "#fff",
          fontFamily: "inherit",
        }}
      >
        {[...Array(maxExamIndex)].map((_, index) => (
          <option key={index + 1} value={index + 1}>
            {worksheet.setLabelList?.[index] || `${index + 1}번 세트`}
          </option>
        ))}
      </select>

      <div className="ws-hint" style={{ marginTop: "12px" }}>
        세트를 고르면 다음 단계에서 그 세트에 포함된{" "}
        <b>지문 목록</b>이 표시됩니다.
      </div>
    </div>
  );
};

export default ComprehensiveSelectionPage;
